'use client';
import { getCookie } from '../utils/getCookie/getCookie.js';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
// TODO: вынести в параметры плагина
var userId = getCookie("ssdcp");
var defaultTransform = function(eventName, payload) {
    return _extends({
        event_name: eventName,
        user_id: userId
    }, payload);
};

export { defaultTransform };
